import { request } from "/src/utils/index.js";

/**
 * 公众号推广列表查询
 */
export function PromotionList(params) {
  return request.get("sdm/marketing/wechat/subscription/list", { params });
}

/**
 * 推广数据汇总
 */
export function PromotionSummary(params) {
  return request.get("sdm/marketing/wechat/subscription/summary", { params });
}

/**
 * 订阅号推广列表查询
 * @param {Object} params { appId, startDate, endDate, clubId }
 */
export function SubscribeList(params) {
  return request.get("wechat/user/subscribe/list", { params });
}

/**
 * 批量确认
 * @param {Array} ids id数组
 */
export function ConfirmBatch(ids) {
  return request.post("wechat/user/confirm/batch", ids);
}

/**
 * 更新备注
 * @param {Object} data { Id, remark }
 */
export function UpdateSubscribeRemark(data) {
  return request.put("wechat/user", data);
}